import type { Project } from '@/components/projects/interfaces.ts'
import { isNull } from 'lodash'

export function generateLinkForLogoClickRedirect (projectSelected: Project | null, path: string = '/chats'): string {
  return isNull(projectSelected) ? path : `/${projectSelected.key}${path}`
}
